import React, { useEffect, useState } from 'react'
import { makeStyles, Container, Grid, Button, Box } from '@material-ui/core';
import {
  Search,
  BackNavAdmin,
  UserCards
} from '../../components';

import { DialogAllInfrastructure } from './../../components/Infrastructure/DialogAllInfrastructure'

import { useWindowSize } from '../../hooks';
import config from '../../config';
import { useSelector, useDispatch } from "react-redux";
import { TypeFilter } from './../../components/Infrastructure/TypeFilter';
import { infraStructureActions } from './../../actions';
import { InfraestructureTable } from './../../components/Tables/InfraestructureTable'
import AddCircle from '@material-ui/icons/AddCircle';
import { history } from '../../helpers';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(4),
  },
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  filters: {
    width: '100%',
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    float: "right"
  }
}));

export const InfraestructurePage = () => {
  const classes = useStyles();
  const [width] = useWindowSize();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {
    paging,
    filters: { types }
  } = useSelector((state) => state.infraStructure);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    dispatch(infraStructureActions.getLocals());
    dispatch(infraStructureActions.getOccupationAreas());
  }, []);

  useEffect(() => {
    dispatch(infraStructureActions.getInfraStructure({ page: 1, limit: 10, types }));
  }, [dispatch, types]);

  function sendQuery(query) {
    dispatch(infraStructureActions.getByName({ name: query }));
  }

  function handleOpenAddInfra() {
    setIsOpen(true)
  }

  function handleCloseAddInfra() {
    setTimeout(() => {
      dispatch(infraStructureActions.getInfraStructure({ page: 1, sort: 'name', limit: 10 }));
    }, 1000)
    setIsOpen(false)
  }


  return (
    <>
      <DialogAllInfrastructure
        open={isOpen}
        typeDialog='add'
        handleClose={handleCloseAddInfra}
      />
      <BackNavAdmin title={t('infraestrutura')}>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          onClick={handleOpenAddInfra}
          startIcon={<AddCircle />}
        >
          {t('adicionar_infraestrutura')}
        </Button>
      </BackNavAdmin>
      <Container maxWidth="lg" className={classes.root}>
        <Box className={classes.filters}>
          <TypeFilter />
          <Box></Box>
          <Search
            placeholder={t('pesquisar_unidade_local_area')}
            value={paging.search}
            query={sendQuery}
          />
        </Box>
        <Grid container>
          <Grid item xs={12}>
            <InfraestructureTable />
          </Grid>
        </Grid>
      </Container>
    </>
  )
}
